import { RefObject } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '@components/ProductCardNew/PromoLabels/PromoLabels.styles';
import CustomizeIcon from '@components/CustomizeIcon/CustomizeIcon';
import { TProductFlagsKey } from '@features/categories/typescript/index';
import { FLAGS_TYPES_NAMES } from '@features/categories/const';
import IsShopMiddleware from '@utils/IsShopMiddleware';
import theme from '@styles/theme';
type PropsType = {
  configurable: boolean;
  hoverRef: RefObject<HTMLAnchorElement>;
  pricePromoPercent: string;
  checkFlagActive: (flagName: TProductFlagsKey) => boolean;
  isSmall?: boolean;
  transparent?: boolean;
};
const Promolabels = ({
  configurable,
  pricePromoPercent,
  checkFlagActive,
  isSmall = false,
  transparent = false,
  hoverRef
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const isNew = checkFlagActive(FLAGS_TYPES_NAMES.novelty);
  const isHotSale = checkFlagActive(FLAGS_TYPES_NAMES.hotSale); // 1
  const isBuenFin = checkFlagActive(FLAGS_TYPES_NAMES.goodSale) && !isHotSale; // 2
  const isSurprise = checkFlagActive(FLAGS_TYPES_NAMES.surpriseSale) && !isHotSale && !isBuenFin; // 3
  const isPromo = pricePromoPercent && !isHotSale && !isBuenFin && !isSurprise;
  const isBlackFriday = checkFlagActive(FLAGS_TYPES_NAMES.blackFriday); // 1
  const isfastShipping = checkFlagActive(FLAGS_TYPES_NAMES.fastShipping) && !isBlackFriday; // 2
  const isBestseller = checkFlagActive(FLAGS_TYPES_NAMES.bestseller) && !isBlackFriday && !isfastShipping; // 3
  return <IsShopMiddleware>
      {configurable && <div sx={styles.customizeButton(isSmall)}>
          <CustomizeIcon hoverRef={hoverRef} background={transparent ? theme.rawColors.neutralWhite : theme.rawColors.lightGreyBgProduct} />
        </div>}
      <div sx={styles.rightLabels(isSmall)}>
        {isBuenFin && <span sx={styles.redLabel(isSmall)}>{t('goodSale')}</span>}
        {isSurprise && <span sx={styles.redLabel(isSmall)}>{t('surprise')}</span>}
        {isHotSale && <span sx={styles.redLabel(isSmall)}>{t('hotSale')}</span>}
        {isPromo && <span sx={styles.redLabel(isSmall)}>{t('specialOffer')}</span>}
        {isBlackFriday && <span sx={styles.blackLabel(isSmall)}>{t('blackFriday')}</span>}
        {isfastShipping && <span sx={styles.blackLabel(isSmall)}>{t('fastShipping')}</span>}
        {isBestseller && <span sx={styles.blackLabel(isSmall)}>{t('bestseller')}</span>}
      </div>
      <div sx={styles.bottomLabels} className="bottom_labels">
        {pricePromoPercent && <span sx={styles.percentLabel(transparent)}>{pricePromoPercent}</span>}
        {isNew && <span sx={styles.whiteLabel(transparent, isSmall)}>{t('new')}</span>}
      </div>
    </IsShopMiddleware>;
};
export default Promolabels;